import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@material-ui/icons/Info";
import { useStyles } from "./ChoixDates.css";
import useStylesThemes from "../../css/globalTheme";

const DomAcordeon = ({
  item,
  index,
  level,
  style,
  style2 = {},
  style3 = {},
  onChange,
  activity,
  dayActivity,
  trancheHoraire,
  selectedValues,
  variant = "h5",
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [cheked, setCheked] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const styleTheme = useStylesThemes()();

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setAllChecked(isChecked);
    const allTranches = trancheHoraire.filter(
      (tranche) =>
        tranche.parentId === item.parentId &&
        tranche.DateActivite === item.DateActivite
    );
    onChange(allTranches, true, isChecked);
    const AllIds = isChecked ? allTranches.map((tranche) => tranche.ID) : [];
    setCheked(AllIds);
  };

  const handleChange = (tranche) => {
    if (onChange) onChange([tranche]);
  };

  useEffect(() => {
    if (level === "3" && open) {
      let tmp = [];
      trancheHoraire
        .filter(
          (tranche) =>
            tranche.parentId === item.parentId &&
            tranche.DateActivite === item.DateActivite
        )
        .forEach((tranche) => {
          if (selectedValues.find((value) => value.ID === tranche.ID)) {
            tmp.push(tranche.ID); // Ajouter au tableau temporaire si existe dans selectedValues
          }
        });
      setCheked(tmp);
      setAllChecked(
        tmp.length ===
          trancheHoraire.filter(
            (tranche) =>
              tranche.parentId === item.parentId &&
              tranche.DateActivite === item.DateActivite
          ).length
      );
    }
  }, [selectedValues, open, item, level, trancheHoraire]);

  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Accordion
      square
      className={level === "3" ? classes.lvl3Accordion : classes.accordion}
      style={{
        ...style2,
        ...(item.NonAutoriser && {
          color: "lightgray",
          pointerEvents: "none",
        }),
      }}
      onChange={(_e, v) => {
        setOpen(v);
      }}
    >
      <AccordionSummary
        style={style}
        className={classes.accordionSummary}
        key={`accordionsum_${index}_${item.ID}`}
        expandIcon={
          item.NonAutoriser ? (
            <Tooltip title={item.InfosRefus || ""}>
              <InfoIcon className={styleTheme.iconColor} />
            </Tooltip>
          ) : (
            <ExpandMoreIcon />
          )
        }
      >
        <Typography
          variant={variant}
          component="span"
          className={item.NonAutoriser ? "disabledText" : ""}
          style={{
            fontWeight: "bold",
            fontSize: level === "1" ? 20 : level === "2" ? 18 : 16,
          }}
        >
          {item.Nom}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        key={`details_${index}_${item.ID}`}
        className={
          level === "2" ? classes.lvl2AccordionDetail : classes.accordionDetail
        }
        style={style3}
      >
        <Typography variant="body2" component="span">
          {item.Description}
        </Typography>
        {open &&
          level === "1" &&
          activity
            .filter((act) => act.parentId === item.ID)
            .map((act, index) => (
              <React.Fragment key={index}>
                <DomAcordeon
                  selectedValues={selectedValues}
                  onChange={onChange}
                  activity={activity}
                  dayActivity={dayActivity}
                  trancheHoraire={trancheHoraire}
                  item={act}
                  level="2"
                  variant="h6"
                  style={{ backgroundColor: "#fff" }}
                  style3={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "baseline",
                    flexDirection: "row",
                    columnGap: "10px",
                  }}
                />
              </React.Fragment>
            ))}
        {open &&
          // LEVEL 2 : Les accordeons dans les activités (tranches)
          level === "2" &&
          dayActivity
            .filter((act) => act.parentId === item.ID && !item.NonAutoriser)
            .map((act, index) => (
              <React.Fragment key={index}>
                <DomAcordeon
                  selectedValues={selectedValues}
                  onChange={onChange}
                  activity={activity}
                  dayActivity={dayActivity}
                  trancheHoraire={trancheHoraire}
                  item={act}
                  level="3"
                  variant="body2"
                  style={{ backgroundColor: "#fff" }}
                  style2={{ backgroundColor: "#fff", minWidth: querysmDown? "280px" : "200px"   }}
                  style3={{ backgroundColor: "#fff"}}
                />
              </React.Fragment>
            ))}
        {open && level === "3" && (
          // Level 3 -> Les checkboxes
          <React.Fragment key={index}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                }
                label="Tout sélectionner"
                classes={{ label: "labelCheckBoxWish" }}
              />
              {trancheHoraire
                .filter(
                  (tranche) =>
                    tranche.parentId === item.parentId &&
                    tranche.DateActivite === item.DateActivite
                )
                .map((tranche, index) => (
                  <FormControlLabel
                    key={`fcl_${index}_${tranche.ID}`}
                    control={
                      <Checkbox
                        key={`ck_${index}_${tranche.ID}`}
                        color="primary"
                        checked={cheked.indexOf(tranche.ID) > -1}
                        onChange={() => handleChange(tranche)}
                        id={`id_${index}_${tranche.ID}`}
                        name={tranche.DateActivite}
                        inputProps={{ "data-parent": item.Activite }}
                        className="checkDate"
                        value={`${tranche.Alias}__${tranche.longDate}__${tranche.shortDate}__${tranche.parentId}__${tranche.parentNom}__${tranche.ID}`}
                      />
                    }
                    label={tranche.Alias}
                    classes={{ label: "labelCheckBoxWish" }}                    
                  />
                ))}
            </FormGroup>
          </React.Fragment>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default DomAcordeon;
